import { Button } from 'modules/Button';
import { Typography } from 'modules/Typography';
import { Falcon } from 'modules/macro';
import { useCalendar } from '../../Context';
export function YearPickerToggleButton() {
    const { locale, timeZone, yearPickerVisible, toggleYearPicker, focusedDate } = useCalendar();
    const yearFormat = new window.Intl.DateTimeFormat(locale, { year: 'numeric', timeZone });
    const month = new window.Intl.DateTimeFormat(locale, {
        month: 'long',
        timeZone,
    });
    return (<Button $stretch appearance="ghost" type="button" onClick={toggleYearPicker} size="xs">
      <Typography $fontWeight="bold">
        {month.format(focusedDate)}
        &nbsp;
        {yearFormat.format(focusedDate)}
      </Typography>
      {yearPickerVisible ? <Falcon icon="chevron-up"/> : <Falcon icon="chevron-down"/>}
    </Button>);
}
